import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EnnisDashboard from "./pages/EnnisDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EnnisDashboard />} />
          <Route path="/s/:symbol" element={<EnnisDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
